import React, { Suspense, useEffect, useState } from 'react';
import { UILocation } from '../redux/reducers/app-reducers';
import { HomePage } from './home';
import { Navigation } from './navigation';
import { SignInPage } from './sign-in/sign-in';
import '../../../its-pages/src/css/its-vars.css';
import {
  LazyAdmin,
  LazyForgotPasswordPage,
  LazyNewAccountPage,
  LazyResources,
  LazySignUpPage,
  LazyStudentHome,
  LazyTeacherHome,
} from './lazy-components';
import { localURL } from '../utils/utils';
import { Loading } from './loading';
import { useClientDispatch, useClientSelector } from '@/redux/hooks';
import { setURLClassroomToken, setURLModule } from '@/redux/actions/app-actions';

export const App = () => {
  const firebaseInitialized = useClientSelector(state => state.firebase.initialized);
  const appLocation = useClientSelector(state => state.app.location);

  const dispatch = useClientDispatch();

  const initializing = !firebaseInitialized;

  const [date] = useState(Date.now());

  useEffect(() => {
    // Check url variables to jump to a specific module and/or class from link
    const classToken = localURL.searchParams.get('classCode');
    if (classToken) dispatch(setURLClassroomToken(classToken));

    // TODO: Should do some validation
    const module = localURL.searchParams.get('module');
    if (module) {
      dispatch(setURLModule(module));
    }
  }, [dispatch]);

  if (initializing) {
    return Date.now() - date > 2000 ? <div>initializing</div> : null;
  }

  const MainBody = () => {
    switch (appLocation) {
      case UILocation.resources:
        return (
          <Suspense fallback={<Loading />}>
            <LazyResources />
          </Suspense>
        );

      case UILocation.admin:
        return (
          <Suspense fallback={<Loading />}>
            <LazyAdmin />
          </Suspense>
        );

      case UILocation.home:
        return <HomePage />;

      case UILocation.teacherHome:
        return (
          <Suspense fallback={<Loading />}>
            <LazyTeacherHome />
          </Suspense>
        );

      case UILocation.studentHome:
        return (
          <Suspense fallback={<Loading />}>
            <LazyStudentHome />
          </Suspense>
        );

      case UILocation.signin:
        return <SignInPage />;

      case UILocation.signup:
        return (
          <Suspense fallback={<Loading />}>
            <LazySignUpPage />
          </Suspense>
        );

      case UILocation.newAccount:
        return (
          <Suspense fallback={<Loading />}>
            <LazyNewAccountPage />
          </Suspense>
        );

      case UILocation.forgotPassword:
        return (
          <Suspense fallback={<Loading />}>
            <LazyForgotPasswordPage />
          </Suspense>
        );

      case UILocation.noRole:
        return <div>LMS server sent no user role.</div>;

      case UILocation.noContext:
        return <div>Tool launched outside of module.</div>;
      default:
        return null;
    }
  };

  return (
    <div>
      <Navigation key={appLocation} />
      <MainBody />
    </div>
  );
};
